export default __webpack_public_path__ + "static/media/editar.d252d3cf.svg";